module.exports = __webpack_public_path__ + "img/AVAJANG-Logo-black.fa7c05bb.png";